var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Cutlery = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M10,8 L10,5 L11,5 L11,11 C11,11.5522847 10.5522847,12 10,12 L10,19 C10,19.5522847 9.55228475,20 9,20 L8,20 C7.44771525,20 7,19.5522847 7,19 L7,12 C6.44771525,12 6,11.5522847 6,11 L6,5 L7,5 L7,8 L8,8 L8,5 L9,5 L9,8 L10,8 Z M10,9 L7,9 L7,11 L8,11 L8,19 L9,19 L9,11 L10,11 L10,9 Z M14,15.0068767 C13.9830426,14.4065664 13.852996,14.0179868 13.6429788,13.820586 C13.2054892,13.4093779 13,12.7929102 13,12 L13,7 C13,5.8954305 13.8954305,5 15,5 L16,5 C16.5522847,5 17,5.44771525 17,6 L17,19 C17,19.5522847 16.5522847,20 16,20 L15,20 C14.4477153,20 14,19.5522847 14,19 L14,15.0068767 Z M15,19 L16,19 L16,6 L15,6 C14.4477153,6 14,6.44771525 14,7 L14,12 C14,12.5404232 14.1181238,12.8947946 14.3278604,13.0919316 C14.7643092,13.5021615 14.9773157,14.1609213 15,15.0068767 L15,19 Z" })));
};
Cutlery.displayName = 'Cutlery';
export default Cutlery;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Cutlery.js.map